import { joinDataTestId } from "@/constants/data-test-ids.utils";

export const starsRatingDataTestIds = {
  component: "stars-rating" as const,
  container: (): string => joinDataTestId(starsRatingDataTestIds.component, "container"),
  star: (index: number | string): string => joinDataTestId(starsRatingDataTestIds.component, "star", String(index)),
};
